import {
  selectLocalPeerID,
  selectPeerMetadata,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";
import type { ParticipantMetadata } from "../types";

export const useHMSLocalMetadata = () => {
  const localPeerId = useHMSStore(selectLocalPeerID);
  const metadata = useHMSStore<ParticipantMetadata>(
    selectPeerMetadata(localPeerId),
  );
  const hmsActions = useHMSActions();
  const setMetadata = (newMetadata: ParticipantMetadata) => {
    void hmsActions.changeMetadata({ ...metadata, ...newMetadata });
  };

  return {
    metadata,
    setMetadata,
  };
};
